import { Moon, Sun } from "@phosphor-icons/react";
import { useTheme } from "@reactive-resume/hooks";
import { Button, Tooltip } from "@reactive-resume/ui";
import { AnimatePresence, motion } from "framer-motion";

type Props = {
  size?: number;
  variant?: "ghost" | "outline";
};

export const ThemeSwitch = ({ size = 20, variant = "ghost" }: Props) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Tooltip content={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}>
      <Button size="icon" variant={variant} onClick={toggleTheme}>
        <AnimatePresence mode="wait" initial={false}>
          {isDarkMode ? (
            <motion.div
              key="sun"
              initial={{ rotate: 90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: -90, opacity: 0 }}
              transition={{ duration: 0.15 }}
            >
              <Sun size={size} weight="fill" />
            </motion.div>
          ) : (
            <motion.div
              key="moon"
              initial={{ rotate: -90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: 90, opacity: 0 }}
              transition={{ duration: 0.15 }}
            >
              <Moon size={size} weight="fill" />
            </motion.div>
          )}
        </AnimatePresence>
      </Button>
    </Tooltip>
  );
};
